export default function ScrollTop  () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };